import { call } from "@saas/api-client";
import { Button, Card, ErrorAlert, formatDate, Loading, PageHeader, Table, TextField, useAsync, useCommand, usePendingId, useSession } from "@saas/ui";
import { useState, type FormEvent } from "react";
import { api } from "./api";

export function AdministratorsPage() {
  const session = useSession();
  const admins = useAsync(() => call(api.GET("/api/administrators")), []);
  const command = useCommand();
  const administratorId = usePendingId();
  const [email, setEmail] = useState("");

  const add = async (event: FormEvent) => {
    event.preventDefault();
    const id = administratorId.idFor(email);
    if (await command.run(() => call(api.POST("/api/administrators", { body: { id, email } })))) {
      administratorId.done();
      setEmail("");
      admins.reload();
    }
  };

  const remove = async (id: string) => {
    if (await command.run(() => call(api.DELETE("/api/administrators/{id}", { params: { path: { id } } })))) admins.reload();
  };

  return (
    <>
      <PageHeader title="Administrators" description="People who can administer the whole product. They sign in with Google Workspace (owner realm)." />
      <Card title="Add an administrator">
        <form className="sb-form" onSubmit={add} noValidate>
          <div className="sb-form-row">
            <TextField label="Email" type="email" required value={email} error={command.fieldError("email")} onChange={(e) => setEmail(e.target.value)} />
            <div className="sb-form-action">
              <Button type="submit" variant="primary" disabled={command.pending}>
                Add administrator
              </Button>
            </div>
          </div>
        </form>
      </Card>
      <Card title="Current administrators">
        <ErrorAlert error={command.error && !command.fieldError("email") ? command.error : admins.error} />
        {admins.loading && !admins.data ? (
          <Loading />
        ) : (
          <Table caption={`${admins.data?.length ?? 0} administrator(s)`} headers={["Email", "Added", ""]}>
            {admins.data?.map((a) => (
              <tr key={a.id}>
                <td>{a.email}</td>
                <td>{formatDate(a.addedAt)}</td>
                <td>
                  <div className="sb-actions">
                    {a.email !== session.email && (
                      <Button small variant="danger" onClick={() => remove(a.id)} aria-label={`Remove ${a.email}`}>
                        Remove
                      </Button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </Table>
        )}
      </Card>
    </>
  );
}
